import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {Box, Divider, IconButton, Tooltip} from '@mui/material';
import {useState} from 'react';

import {ExportField} from '../../interfaces/Export';
import {GasMonitoringNodeListQuery} from '../../interfaces/GasMonitoringNode';
import ExportPdfButton from '../common/ExportPdfButton';
import ModalFixed from '../common/ModalFixed';
import AMSLongTermHistoryExportExcel from './AMSLongTermHistoryExportExcel';

interface Props {
  value?: {
    exportFields?: ExportField[];
    params?: GasMonitoringNodeListQuery;
    emoduleId?: string;
  };
}

const AMSLongTermHistoryExportButton = ({value}: Props) => {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Tooltip title="Export">
        <FileDownloadIcon onClick={() => setIsOpened(true)} />
      </Tooltip>

      {isOpened ? (
        <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
          <Box
            display="flex"
            flexDirection="column"
            position="relative"
            gap={3}
            p={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" alignItems="center" width="100%" gap={1.5}>
                <FileDownloadIcon sx={{color: 'primary.main'}} />
                <Box fontSize={24}>Export AMS Long Term History</Box>
              </Box>
              <IconButton onClick={() => setIsOpened(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              position="relative"
              gap={3}
            >
              <Divider>Export</Divider>
              <AMSLongTermHistoryExportExcel value={value} />
              <ExportPdfButton
                endpoint={`/ams/${value?.emoduleId}/long-term-history`}
                defaultFilename="ams_long_term_history.pdf"
                params={value?.params as Record<string, unknown> | undefined}
                exportFields={value?.exportFields}
              />
            </Box>
          </Box>
        </ModalFixed>
      ) : null}
    </>
  );
};

export default AMSLongTermHistoryExportButton;
